document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(function () {
  const headerSection = document.querySelector('.shopify-section.header-section');

  if (headerSection) {
    const onScroll = () => {
      headerSection.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();

(function () {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  const backdrop = document.querySelector('.site-header__nav-backdrop');
  const closeBtns = document.querySelectorAll('[data-menu-close]');

  if (!toggle || !nav) return;

  const closeMenu = () => {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    if (backdrop) backdrop.hidden = true;
  };

  const openMenu = () => {
    nav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    if (backdrop) backdrop.hidden = false;
  };

  toggle.addEventListener('click', () => {
    if (nav.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  closeBtns.forEach((btn) => btn.addEventListener('click', closeMenu));

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  nav.querySelectorAll('[data-nav-dropdown]').forEach((item) => {
    const toggleBtn = item.querySelector('[data-nav-dropdown-toggle]');
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = item.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();

(function () {
  const drawer = document.querySelector('[data-search-drawer]');
  const openBtn = document.querySelector('[data-search-open]');
  if (!drawer || !openBtn) return;

  const input = drawer.querySelector('.search-drawer__input');
  const closeEls = drawer.querySelectorAll('[data-search-close]');

  const openSearch = () => {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-open');
    if (input) setTimeout(() => input.focus(), 50);
  };

  const closeSearch = () => {
    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-open');
    setTimeout(() => {
      drawer.hidden = true;
    }, 250);
  };

  openBtn.addEventListener('click', openSearch);
  closeEls.forEach((el) => el.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeSearch();
    }
  });
})();

(function () {
  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;

    const track = carousel.querySelector('[data-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const gallery = carousel.closest('[data-product-gallery]');
    const thumbs = gallery
      ? Array.from(gallery.querySelectorAll('[data-gallery-thumb]'))
      : [];

    if (!track || slides.length < 2) return;

    let index = 0;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      slides.forEach((slide, i) => {
        const link = slide.querySelector('a');
        if (link) link.tabIndex = i === index ? 0 : -1;
      });
    };

    carousel.goTo = goTo;
    carousel.dataset.carouselReady = 'true';

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(index + 1);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(Number(dot.dataset.carouselDot) || 0);
      });
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(Number(thumb.dataset.carouselIndex) || 0);
      });
    });

    track.addEventListener(
      'touchstart',
      (event) => {
        startX = event.touches[0].clientX;
        deltaX = 0;
        dragging = true;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      (event) => {
        if (!dragging) return;
        deltaX = event.touches[0].clientX - startX;
      },
      { passive: true }
    );

    track.addEventListener('touchend', () => {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      }
      deltaX = 0;
    });

    goTo(0);
  };

  const initCarousels = (root = document) => {
    root.querySelectorAll('[data-carousel]').forEach(initCarousel);
  };

  window.SoieTheme = window.SoieTheme || {};
  window.SoieTheme.initCarousels = initCarousels;
  initCarousels();
})();

(function () {
  const forms = document.querySelectorAll('[data-product-form]');

  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-variant-data]');
    const idInput = form.querySelector('[data-variant-id]');
    const selectors = Array.from(form.querySelectorAll('[data-option-selector]'));
    const button = form.querySelector('[data-add-button]');

    if (!dataEl || !idInput || selectors.length === 0) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    selectors.sort(
      (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );

    const scope = form.closest('.product-page') || document;
    const priceContainer = scope.querySelector('[data-price-container]');
    const gallery = scope.querySelector('[data-product-gallery]');

    const showVariantMedia = (mediaId) => {
      if (!gallery || !mediaId) return;
      const slides = Array.from(gallery.querySelectorAll('[data-carousel-slide]'));
      const target = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      const carousel = gallery.querySelector('[data-carousel]');
      if (target > -1 && carousel && typeof carousel.goTo === 'function') {
        carousel.goTo(target);
      }
    };

    const renderPrice = (variant) => {
      if (!priceContainer) return;
      const price = document.createElement('span');
      price.className = variant.on_sale ? 'price price--on-sale' : 'price';

      if (variant.on_sale) {
        const compare = document.createElement('s');
        compare.className = 'price--compare';
        compare.textContent = variant.compare_at_price;

        const sale = document.createElement('span');
        sale.className = 'price--sale';
        sale.textContent = variant.price;

        price.append(compare, sale);
      } else {
        const amount = document.createElement('span');
        amount.textContent = variant.price;
        price.append(amount);
      }

      priceContainer.replaceChildren(price);
    };

    const update = () => {
      const chosen = selectors.map((select) => select.value);
      const variant = variants.find(
        (candidate) =>
          candidate.options.length === chosen.length &&
          candidate.options.every((value, index) => value === chosen[index])
      );

      if (!variant) {
        idInput.value = '';
        if (button) {
          button.disabled = true;
          button.textContent = button.dataset.textUnavailable;
        }
        return;
      }

      idInput.value = variant.id;

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? button.dataset.textAdd
          : button.dataset.textSoldOut;
      }

      renderPrice(variant);
      showVariantMedia(variant.media_id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    selectors.forEach((select) => select.addEventListener('change', update));
    update();
  });
})();

(function () {
  const form = document.querySelector('[data-cart-form]');
  if (!form) return;

  const submitUpdate = () => {
    const trigger = form.querySelector('[data-cart-update]');
    if (trigger && typeof form.requestSubmit === 'function') {
      form.requestSubmit(trigger);
    } else {
      form.submit();
    }
  };

  form.querySelectorAll('[data-quantity-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('[data-quantity]').querySelector('input');
      if (!input) return;

      const current = Number(input.value) || 0;
      const next = Math.max(0, current + Number(button.dataset.quantityStep));
      if (next === current) return;

      input.value = next;
      submitUpdate();
    });
  });

  form.querySelectorAll('[data-quantity] input').forEach((input) => {
    input.addEventListener('change', submitUpdate);
  });

  const clearButton = form.querySelector('[data-cart-clear]');
  if (clearButton) {
    clearButton.addEventListener('click', (event) => {
      if (!window.confirm(clearButton.dataset.confirm)) {
        event.preventDefault();
      }
    });
  }
})();

(function () {
  const sortSelect = document.querySelector('[data-collection-sort]');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
})();

(function () {
  const sentinel = document.querySelector('[data-infinite-scroll]');
  const grid = document.querySelector('[data-product-grid]');
  if (!sentinel || !grid) return;

  let nextUrl = sentinel.dataset.nextUrl || '';
  let loading = false;
  const status = sentinel.querySelector('[data-infinite-status]');

  const setLoading = (isLoading) => {
    loading = isLoading;
    if (status) status.hidden = !isLoading;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        loadMore();
      }
    },
    { rootMargin: '400px 0px' }
  );

  async function loadMore() {
    if (!nextUrl || loading) return;

    setLoading(true);

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Failed to load products');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-product-grid]');
      const nextSentinel = doc.querySelector('[data-infinite-scroll]');

      if (nextGrid) {
        Array.from(nextGrid.children).forEach((card) => {
          grid.appendChild(card);
        });

        if (window.SoieTheme && typeof window.SoieTheme.initCarousels === 'function') {
          window.SoieTheme.initCarousels(grid);
        }
      }

      nextUrl = nextSentinel && nextSentinel.dataset.nextUrl ? nextSentinel.dataset.nextUrl : '';
      if (!nextUrl) {
        observer.disconnect();
        sentinel.removeAttribute('data-next-url');
      }
    } catch (error) {
      nextUrl = '';
      observer.disconnect();
    } finally {
      setLoading(false);
    }
  }

  if (nextUrl) {
    observer.observe(sentinel);
  }
})();

(function () {
  const popup = document.querySelector('[data-promo-popup]');
  if (!popup) return;

  const storageKey = 'soie_promo_session_seen';
  let seen = false;

  try {
    seen = window.sessionStorage.getItem(storageKey) === '1';
  } catch (error) {
    seen = false;
  }

  if (seen) return;

  const markSeen = () => {
    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      /* ignore storage errors */
    }
  };

  const closeEls = popup.querySelectorAll('[data-promo-close]');
  const closePopup = () => {
    markSeen();
    popup.classList.remove('is-open');
    document.body.classList.remove('promo-open');
    setTimeout(() => {
      popup.hidden = true;
    }, 280);
  };

  const openPopup = () => {
    markSeen();
    popup.hidden = false;
    document.body.classList.add('promo-open');
    requestAnimationFrame(() => popup.classList.add('is-open'));
  };

  closeEls.forEach((el) => el.addEventListener('click', closePopup));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  window.setTimeout(openPopup, 700);
})();
